import { BrowserStorageInterface } from './storage.interface';
import { BrowserWindowStorageInterface } from './window-storage.interface';
import { BrowserStorageLocalServiceInterface } from '../../service/browser-storage-local/service.interface';
import { BrowserStorageSessionServiceInterface } from '../../service/browser-storage-session/service.interface';

export class BrowserStorage
  implements BrowserStorageInterface, BrowserStorageLocalServiceInterface, BrowserStorageSessionServiceInterface
{
  /**
   * Storage system (window.localStorage, window.sessionStorage, ...)
   */
  protected storage: BrowserWindowStorageInterface;

  /**
   * Sets the storage system
   *
   * @param storage
   */
  public setStorage(storage: BrowserWindowStorageInterface): void {
    this.storage = storage;
  }

  /**
   * @inheritDoc
   */
  public setData(key: string, value: number | string | object): void {
    try {
      // Stringify objects
      const str = typeof value === 'object' ? JSON.stringify(value) : value.toString();

      this.getStorage().setItem(key, str);
    } catch (e) {
      console.error('Unable to stringify value');
    }
  }

  /**
   * @inheritDoc
   */
  public getData(key: string): null | string | object {
    let value: null | string = this.getStorage().getItem(key);

    // Value found is a serialized object
    if (typeof value === 'string' && value.match(/^({.*})|(\[.*\])$/g) !== null) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        console.error('BrowserStorageLocal is unable to parse [key:', key, '][value:', value, ']');
      }
    }

    return value;
  }

  /**
   * @inheritDoc
   */
  public removeData(key: string): void {
    try {
      this.getStorage().removeItem(key);
    } catch (e) {
      console.error('BrowserStorageLocal is unable to removeItem [', key, '] from storage');
    }
  }

  /**
   * Returns the storage system or throws an exception if the storage is not defined
   */
  protected getStorage(): BrowserWindowStorageInterface {
    if (!this.storage) {
      throw new Error('Storage not defined in BrowserStorage');
    }

    return this.storage;
  }
}
